import { getOrRefreshAccessToken } from './session'
import { Socket, Manager } from 'socket.io-client'

let socket: Socket | null = null
let manager: Manager | null = null
type ConnectionChangedListener = (isConnected: boolean) => void
let connectionChangedListener: ((isConnected: boolean) => void) | null = null

function registerConnectionChangedListener(listener: ConnectionChangedListener) {
  connectionChangedListener = listener
}

function onConnect() {
  if (connectionChangedListener) {
    connectionChangedListener(true)
  }
}

function onDisconnect() {
  if (connectionChangedListener) {
    connectionChangedListener(false)
  }
}

async function onReconnectAttempt() {
  const accessToken = await getOrRefreshAccessToken()
  if (socket) {
    socket.auth = { token: accessToken }
  }
}

const initWebSocket = async () => {
  const wsEndpoint = getWSEndpoint()
  if (wsEndpoint) {
    const token = await getOrRefreshAccessToken()
    manager = new Manager(wsEndpoint, { transports: ['websocket'] })
    socket = manager.socket('/', {
      auth: {
        token
      }
    })
    socket.on('connect', onConnect)
    socket.on('disconnect', onDisconnect)
    manager.on('reconnect_attempt', onReconnectAttempt)

    return socket
  }

  return null
}

const disconnectWebSocket = () => {
  if (socket) {
    socket.off('connect', onConnect)
    socket.off('disconnect', onDisconnect)
    socket.disconnect()
  }
  if (manager) {
    manager.off('reconnect_attempt', onReconnectAttempt)
  }
}

const getWSEndpoint = () => {
  // Priority 1: Use the same WebSocket URL as the announcement service for consistency
  if (process.env.NEXT_PUBLIC_WEBSOCKET_URL) {
    return process.env.NEXT_PUBLIC_WEBSOCKET_URL
  }

  return process.env.NEXT_PUBLIC_R365_API_AU
}

export { initWebSocket, disconnectWebSocket, registerConnectionChangedListener }
